import React from "react";
import RightChevron from "./RightChevron";
const CustomizableHelpAd = ({
  className,
  email
}: {
  className?: string;
  email: string;
}) => <aside className={`overflow-hidden grid grid-cols-1 rounded border border-solid border-[#dbdfd8] md:grid-cols-2 ${className}`}
// sf stylesheets causing problems again
style={{
  borderBottom: "1px solid #dbdfd8",
  borderRadius: ".25rem"
}} data-sentry-component="CustomizableHelpAd" data-sentry-source-file="index.tsx">
    <div className="bg-[#f1edf9] flex gap-5 md:gap-12 xl:gap-5 justify-center items-center md:col-span-2 p-8">
      <img className="w-[110px] h-[119px] md:w-[170px] md:h-[191px] xl:w-[110px] xl:h-[119px]" alt="" src="https://www.webstaurantstore.com/uploads/design/2024/8/customizable/cs_rep.png" />
      <div className="">
        <h3 className="text-2xl leading-[22px] font-bold mb-2">
          Get Expert Help!
        </h3>
        <p className="text-sm max-w-[289px] text-[#3B4238]">
          Connect with our dedicated team to make sure your customizable project
          goes smoothly!
        </p>

        <a target="_blank" rel="noopener noreferrer" href={`mailto:${email}`}>
          <div style={{
          textShadow: "0 1px 0 rgba(0, 0, 0, .25)"
        }} className="mt-4 border border-opacity-10 text-sm leading-5 text-white bg-[#3b276a] hover:bg-[#2D1D51] font-semibold rounded w-[163px] h-[29px] flex items-center justify-center">
            Consult an Expert
          </div>
        </a>
      </div>
    </div>

    <div className="bg-white p-8 flex gap-6 items-center md:flex-col-reverse xl:flex-row">
      <div className="md:mr-auto">
        <h3 className="text-xl leading-6 font-bold mb-2">How it works</h3>
        <p className="text-sm leading-4-1/8 mb-2 max-w-[296px] text-[#3B4238]">
          Choose a product to customize, add your logo, and work with our team
          to get your product ordered!
        </p>
        <div className="text-sm font-bold leading-4 mb-1 text-[#298200]">
          <a className="flex items-center gap-2" href="/article/509/how-to-customize-products.html">
            Common FAQs
            <RightChevron data-sentry-element="RightChevron" data-sentry-source-file="index.tsx" />
          </a>
        </div>
        <div className="text-sm font-bold leading-4 text-[#298200]">
          <a className="flex items-center gap-2" href="/article/509/how-to-customize-products.html">
            How-To Guide
            <RightChevron data-sentry-element="RightChevron" data-sentry-source-file="index.tsx" />
          </a>
        </div>
      </div>
      <img className="w-[142px] h-[142px] md:mr-auto xl:mr-0" src="https://www.webstaurantstore.com/uploads/design/2024/8/customizable/cycle.png" alt="customizaton process lifecycle" />
    </div>

    <div className="bg-white border-0 border-t border-solid border-[#dbdfd8] p-8 flex gap-6 items-center md:border-t-0 md:border-l md:flex-col xl:flex-row xl:border-0 xl:border-t xl:border-solid xl:border-t-[#dbdfd8]">
      <img className="h-[142px] w-[142px] md:mr-auto xl:mr-0" alt="light brown cup with custom artwork" src="https://www.webstaurantstore.com/uploads/design/2024/8/customizable/cup.png" />
      <div className="md:mr-auto">
        <h3 className="text-xl leading-6 font-bold mb-2">
          Need help with logo quality?
        </h3>
        <p className="text-sm leading-4-1/8 mb-2 max-w-[296px] text-[#3B4238]">
          {}
          Send us your artwork and we'll make sure your products look their
          best.
        </p>
        {}
        <div className="text-sm font-bold leading-4 text-[#298200]">
          <a className="flex items-center gap-2" href="/services/artwork-file-prep/">
            Learn More
            <RightChevron data-sentry-element="RightChevron" data-sentry-source-file="index.tsx" />
          </a>
        </div>
      </div>
    </div>
  </aside>;
export default CustomizableHelpAd;